<template>
  <page>
    <v-card>
      <!-- <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title v-if="query">Miscellaneous Claims Parameters
          <v-btn text color="primary" v-on="on" @click="query = false" v-if="query">
            Edit
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
        </v-toolbar-title>
        <v-toolbar-title v-else>Upload Treaty Premium & Commission</v-toolbar-title>
      </v-toolbar> -->
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xl6 md6 xs12>
              <cal-picker
                :label="labels.fromDate"
                v-model="form.fromDate"
                :error-messages="errors.collect('fromDate')"
                data-vv-name="fromDate"
                :data-vv-as="labels.fromDate"
                v-validate="'required'"
              ></cal-picker>
            </v-flex>
            <v-flex xl6 md6 xs12>
              <cal-picker
                :label="labels.toDate"
                v-model="form.toDate"
                :error-messages="errors.collect('toDate')"
                data-vv-name="toDate"
                :data-vv-as="labels.toDate"
                v-validate="'required'"
              ></cal-picker>
            </v-flex>
            <v-flex xl6 md6 xs12>
              <cal-picker
                :label="labels.acctEndPeriod"
                v-model="form.acctEndPeriod"
                :error-messages="errors.collect('acctEndPeriod')"
                data-vv-name="acctEndPeriod"
                :data-vv-as="labels.acctEndPeriod"
                v-validate="'required'"
              ></cal-picker>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                :label="labels.createTtyMaster"
                v-model="form.createTtyMaster"
                data-vv-name="createTtyMaster"
                :data-vv-as="labels.createTtyMaster"
                :error-messages="errors.collect('createTtyMaster')"
                hide-details
              ></v-checkbox>
            </v-flex>
            <v-flex xl6 md6 xs12>
              <v-text-field
                ref="stmtRef"
                v-model="form.stmtRef"
                :label="labels.stmtRef"
                :error-messages="errors.collect('stmtRef')"
                data-vv-name="stmtRef"
                :data-vv-as="labels.stmtRef"
                v-validate="'required'" :maxlength="10"></v-text-field>
            </v-flex>
          </v-layout>
          <v-dialog v-model="showErrorDialog" width="800px">
            <v-card>
              <v-toolbar dense color="grey lighten-3" flat>
                <v-icon>mdi-information</v-icon>
                <v-toolbar-title>System Information</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div v-if="messages.length > 0" class="pb-3">
                  <span class="info-dialog-msg-header">Oops something went wrong...</span>
                  <v-spacer class="mt-2"></v-spacer>
                  <ul class="showErrorMsgs">
                    <li v-for="(error, index) in messages" :key="index">
                      {{ error.message }}
                    </li>
                  </ul>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
        <v-btn color="error" dark class="mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn color="primary" dark class="mr-2" @click="doUpload" :loading="submitting">
        Save
        <v-icon right>mdi-content-save </v-icon>
      </v-btn>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      uploadTtyPremComm: 'uploadTtyPremComm',
      submitting: false,
      showErrorDialog: false,
      labels: {
        fromDate: 'From Date',
        toDate: 'To Date',
        acctEndPeriod: 'Account End Period',
        createTtyMaster: 'Create New Treaty Master',
        uploadTtyPremComm: 'Upload Treaty Premium & Commission',
        stmtRef: 'Statement Reference'
      },
      form: {
        fromDate: undefined,
        toDate: undefined,
        acctEndPeriod: undefined,
        createTtyMaster: true,
        stmtRef: undefined
      },
      query: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('uploadTreatyPremCommInit')])
    },
    doCancel() {
      this.$router.push({ name: 'specFuncTtyAcct' })
    },
    doUpload() {
      this.submitting = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          // console.log('doUpload')
          this.getUploadProcess()
        } else {
          this.promptFieldCheck()
          this.submitting = false
        }
      })
    },
    async getUploadProcess() {
      const apiURI = this.menu.getUploadProcess
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, this.form))
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
            // this.$router.push({ name: 'uploadTtyPremComm' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.specFuncTtyAcct.uploadTreatyPremComm.menu
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>
